import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const TaxPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/tax/lodge-return');
  }, []);
  return (
    <>
      <ApplicationSubHeading title="Tax Page" />
    </>
  );
};

export default TaxPage;
